<template>
  <div>
    <div @click="goadd">{{$store.state.count}}</div>
    <div v-for="(item,index) in arrs">
      <el-upload class="upload-demo" :action="uploadUrl" show-file-list :file-list="imglist" :limit="9" :on-success="(res, file, fileList)=>{return handleInfoSuccess(res, file, fileList,index)}" :on-remove="(file, fileList)=>{return handleInfoRemove(file, fileList,index)}" list-type="picture-card">
        <i class="el-icon-plus"></i>
      </el-upload>
    </div>
  </div>
</template>

<script>
export default {
  props: {

  },
  data() {
    return {
      imglist: [],
      uploadUrl:'http://myhomecq.sublab.cn//api/common/upload_file',
      imgurl: '',
      arrs: [
        {
          imglist: [],
        },
        {
          imglist: [],
        },
        {
          imglist: [],
        },
        {
          imglist: [],
        }
      ]
    };
  },
  computed: {

  },
  created() {

  },
  methods: {
    goadd() {
      this.$store.dispatch("addcount");
    },
    // 产品详情 图片上传成功
    handleInfoSuccess(res, file, fileList, index) {
        console.log(file)
      var imgObject = {
        "url": this.GLOBAL.BASE_URL + res.data,
        'name':file.name
      }
      this.arrs[index].imglist.push(imgObject)
    },
    // 产品详情 图片删除成功
    handleInfoRemove(file, fileList, index) {
      console.log(file)
      this.imgurl = file.url;
      if (file.response) {
        this.imgurl = file.name;
      } else {
        this.imgurl = file.url.split('.cn/')[1];
      }
      console.log(this.imgurl)
      var arr = this.imglist;
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].name == this.imgurl) {
          this.arrs[index].imglist.splice(i, 1)

        }
      }

    },
  },
};
</script>

<style  lang="less">
</style>



// WEBPACK FOOTER //
// src/components/assessment/test.vue